import GameSprite from "../components/GameSprite";
import Entity from "../components/Entity";
import Physics from "../components/Physics";
import C_Entity from "../../const/C_Entity";
import C_Physics from "../../const/C_Physics";
import FlierLogic from "../components/FlierLogic";
import ProjectileLogic from "../components/ProjectileLogic";
import EnemySpawner from "../components/EnemySpawner";
import AsteroidSpawner from "../components/AsteroidSpawner";
import Point3D from "../math/Point3D";
import EnemyProjectileLogic from "../components/EnemyProjectileLogic";
import MoonProjectileLogic from "../components/MoonProjectileLogic";
import FriendlyBot from "../components/FriendlyBot";
import GameAnimation from "../components/GameAnimation";
import MathUtil from "../utils/MathUtil";
import C_ViewType from "../../const/C_ViewType";
import BotsController from "../components/BotsController";
import FormationSpawner from "../components/FormationSpawner";
import C_FormationType from "../../const/C_FormationType";
import FakeProjectileLogic from "../components/FakeProjectileLogic";

class EntityFactory
{


    constructor()
    {
        this.app = PIXI.app;
    }


    setViewType(viewType)
    {
        this.viewType = viewType;
    }


    getViewType()
    {
        return this.viewType;
    }


    getEnemySpawner()
    {
        let e = new Entity(C_Entity.SPAWNER);
        e.addComponent(new EnemySpawner());
        return e;
    }


    getAsteroidSpawner()
    {
        let e = new Entity(C_Entity.ASTEROID_SPAWNER);
        e.addComponent(new AsteroidSpawner());
        return e;
    }


    getFlier()
    {
        let e = new Entity(C_Entity.FLIER);

        let p = new Physics();

        let startX = 4 + Math.random()*30 * (Math.random() > .5 ? 1 : -1);
        let startY = 4 + Math.random()*20 * (Math.random() > .5 ? 1 : -1);
        p.setPosition(startX, startY, 500 + Math.random() * 500);
        p.setVelocity(0,0,-150 + Math.random() * -150);
        p.setSize(4);
        p.initPhysics(C_Physics.PASSIVE, 6);

        let s = new GameSprite("ship_1");
        s.fadeInTime = 1;

        let l = new FlierLogic();

        e.addComponent(p);
        e.addComponent(s);
        e.addComponent(l);

        return e;
    }


    getProjectile(pos, velocity, size = 2, room = null, botId = null, target = null, parentProjLogic = null)
    {
        let isFakeProjectile = parentProjLogic != null;

        let e = new Entity(C_Entity.WEAPON_PROJECTILE);

        let p = new Physics();
        p.setSpriteRendered(false);
        p.setPosition(pos.x, pos.y, pos.z);
        p.setVelocity(velocity.x, velocity.y, velocity.z);
        p.setSize(size);
        p.initPhysics(C_Physics.ACTIVE, size / 2);

        if (isFakeProjectile)
        {
            p.physicsActive = false;
        }

        let roomId = (room == null) ? this.app.model.getRoomId() : room;
        let texName;
        let namePostfix = "";
        if (botId == 1) namePostfix = "_left";
        else if (botId == 2) namePostfix = "_right";

        if (roomId == 0)
        {
            texName = "projectile_empty";
        }
        else if (roomId == 1)
        {
            texName = "cockpit_2_proj_anim" + namePostfix + "_0";
        }
        else if (roomId == 2)
        {
            texName = "beam" + namePostfix;
        }

        let s = new GameSprite(texName);

        if (roomId == 1) {
            s.setupAnimation("cockpit_2_proj_anim" + namePostfix + "_", 5, 5);
        }

        if (this.getViewType() == C_ViewType.TOP)
        {
            s.setSize(size);
        }
        s.fadeInTime = .1;

        let l;
        if (isFakeProjectile)
        {
            l = new FakeProjectileLogic(botId, parentProjLogic);
        }
        else
        {
            l = new ProjectileLogic(botId);
        }

        if (target)
        {
            l.target = target.getComponent(Physics);
            l.autoLock = true; // Have the flag because you can set lockedTarget on Physics to True on other conditions
            p.lockedTarget = target;
            l.timeBeforeAutoTarget = 0; // we want the projectiles directly to go to their target
        }

        if (roomId == 0)
        {
            l.isBeam = true;
            s.isBeam = true;
            p.velocity.normalize(); // otherwise it travels a distance before the Beam settings and hits targets
            // l.active = false;
        }
        if (roomId == 1)
        {
            l.isElectricity = true;
            s.isElectricity = true;
        }
        else if (roomId == 2)
        {
            l.isLaser = true;
            s.isLaser = true;
        }

        e.addComponent(p);
        e.addComponent(s);
        e.addComponent(l);

        return e;
    }


    getEnemyProjectile(pos, flierSpeed)
    {
        let e = new Entity(C_Entity.ENEMY_PROJECTILE);

        let isAccurate = Math.random() < .2;

        pos.z -= 1;

        let hitX = Math.random()*4 - 2;
        let hitY = Math.random()*3 - 1.5;
        let origin = isAccurate ? new Point3D(hitX,hitY,0) : new Point3D(0,0,-100);
        let velocity = origin.subtract(pos);
        velocity.normalize();
        velocity.scale(flierSpeed + 80);

        let p = new Physics();
        p.setSpriteRendered(false);
        p.setPosition(pos.x, pos.y, pos.z);
        p.setVelocity(velocity.x, velocity.y, velocity.z);
        let pSize = (this.getViewType() == C_ViewType.TOP) ? 0.2 : 1.5;
        p.setSize(pSize);
        p.initPhysics(C_Physics.ACTIVE, 0.1);
        p.physicsActive = false;

        let s = new GameSprite("enemy_projectile");
        if (this.getViewType() == C_ViewType.TOP)
        {
            s.setSize(pSize);
        }
        s.fadeInTime = .05;
        TweenMax.to(s.sprite, 1, {rotation:Math.PI*2, repeat:-1, ease:Linear.easeNone});

        let l = new EnemyProjectileLogic();
        l.isAccurate = isAccurate;

        e.addComponent(p);
        e.addComponent(s);
        e.addComponent(l);

        return e;
    }


    getMotmProjectile(pos, size, textureId)
    {
        let e = new Entity(C_Entity.ENEMY_PROJECTILE);

        let isAccurate = Math.random() < .5;

        pos.z -= 1;

        let randPosX = [5, -5];
        let randPosY = [0, 3, -3, 5, -5];
        let hitX = Math.random()*4 - 2;
        let hitY = Math.random()*3 - 1.5;
        let origin = isAccurate ? new Point3D(hitX,hitY,0) :
            new Point3D(randPosX[MathUtil.getRandomInt(0, 1)],randPosY[MathUtil.getRandomInt(0, 4)],0);
        // let origin = isAccurate ? new Point3D(0,0,-20) : new Point3D(0,0,-100);
        let velocity = origin.subtract(pos);
        velocity.normalize();
        velocity.scale(100);

        let p = new Physics();
        p.setSpriteRendered(false);
        // p.stopMove = true;
        p.setPosition(pos.x, pos.y, pos.z);
        p.setVelocity(velocity.x, velocity.y, velocity.z);
        p.setSize(size);
        p.initPhysics(C_Physics.ACTIVE, 0.1);
        p.physicsActive = false;

        let s = new GameSprite(textureId);
        s.fadeInTime = .05;
        // TweenMax.to(s.sprite, 1, {rotation:Math.PI*2, repeat:-1, ease:Linear.easeNone});

        let l = new MoonProjectileLogic();
        l.isAccurate = isAccurate;

        e.addComponent(p);
        e.addComponent(s);
        e.addComponent(l, EnemyProjectileLogic);

        return e;
    }


    createMoon()
    {
        let e = new Entity(C_Entity.MOON);

        let p = new Physics();
        p.setPosition(70, -50, 1120);
        p.setSize(90);
        p.initPhysics(C_Physics.NONE, 45);

        let s = new GameSprite("moon");
        s.sprite.specialId = 1;

        e.addComponent(p);
        e.addComponent(s);

        this.app.eSys.addEntity(e);
    }


    playRandomExplosion()
    {
        let randDelay = MathUtil.getRandomInt(0, 5);
        TweenMax.delayedCall(10 + randDelay, this.playExplosion.bind(this));
        TweenMax.delayedCall(10 + randDelay, this.playRandomExplosion.bind(this));
    }


    playExplosion()
    {
        let e = new Entity(C_Entity.EXPOLOSION);

        let p = new Physics();
        p.setPosition(-200 + MathUtil.getRandomInt(0, 400), -120 + MathUtil.getRandomInt(0, 240), 1100 + MathUtil.getRandomInt(0, 500));
        p.setSize(40);
        p.initPhysics(C_Physics.NONE, 20);

        let textures = this.app.assets.generateFrames("explosion_space_", 3, 0, 5);

        let s = new GameAnimation(textures);

        e.addComponent(p);
        e.addComponent(s, GameSprite);

        this.app.eSys.addEntity(e);
    }


    // position - the rotation it should apply
    getBot(name, position, badgeId)
    {
        let e = new Entity(C_Entity.FRIENDLY_BOT);
        e.botId = position;

        let data =
        {
            1:
            {
                scale: 1,
                positionX: this.app.layout.relWidth(0),
                offXWidthScale: 0,
                balanceRelX: 60,
                coinRelX: 50,
                nameRelX: 20,
                projectileRelPos:
                {
                    0: [new PIXI.Point(8, 6)],
                    1: [new PIXI.Point(0, 5), new PIXI.Point(10, 5)],
                    2: [new PIXI.Point(0, 5), new PIXI.Point(5, 5), new PIXI.Point(10, 5)],
                },
                // projectileRelPos: new PIXI.Point(5, 5),
                postfix: "_left",
                badgeId: badgeId
            },
            2:
            {
                scale: -1,
                positionX: this.app.layout.relWidth(100),
                offXWidthScale: 1,
                balanceRelX: 17,
                coinRelX: 7,
                nameRelX: -20,
                projectileRelPos:
                {
                    0: [new PIXI.Point(92, 6)],
                    1: [new PIXI.Point(90, 5), new PIXI.Point(100, 5)],
                    2: [new PIXI.Point(90, 5), new PIXI.Point(95, 5), new PIXI.Point(100, 5)],
                },
                // projectileRelPos: new PIXI.Point(5, 5),
                postfix: "_right",
                badgeId: badgeId
            }
        };

        data[position].name = name;

        let b = new FriendlyBot(data[position], position);

        e.addComponent(b);

        // this.app.eSys.addEntity(e);
        return e;
    }


    runBotsController()
    {
        let e = new Entity(C_Entity.BOT_SPAWN_CONTROLLER);

        let bCtrl = new BotsController();
        e.addComponent(bCtrl);

        this.app.eSys.addEntity(e);
    }


    createEnemySpawners()
    {
        //-----------------------//
        //--EnemyShips-spawners--//
        //-----------------------//
        let enemyShipsData = [];
        if (this.viewType == C_ViewType.TOP)
        {
            enemyShipsData =
            [
                {
                    pos: [new Point3D(-25, -50, 419), new Point3D(25, -50, 419.5)],
                    range: new Point3D(20, 0, 0),
                    spawnerWaveDelay: 30,
                    offDelay: 30,
                    angleMin: [Math.PI*2 - Math.PI*1/5, Math.PI + Math.PI*1/5],
                    angleMax: [Math.PI*2 - Math.PI*2/3, Math.PI + Math.PI*2/3],
                    ids:[1,2,3,4]
                },
                {
                    pos: [new Point3D(-25, 50, 393), new Point3D(25, 50, 396.3)],
                    range: new Point3D(20, 0, 0),
                    spawnerWaveDelay: 30,
                    offDelay: 30,
                    angleMin: [Math.PI - Math.PI*1/5, Math.PI*1/5],
                    angleMax: [Math.PI - Math.PI*2/3, Math.PI*2/3],
                    ids:[1,2,3,4]
                },
                {
                    pos: [new Point3D(-85, 0, 400.3), new Point3D(85, 0, 401.3)],
                    range: new Point3D(20, 0, 0),
                    spawnerWaveDelay: 30,
                    offDelay: 30,
                    angleMin: [Math.PI*2 - Math.PI*1/6, Math.PI - Math.PI*1/6],
                    angleMax: [Math.PI*2 + Math.PI*1/6, Math.PI + Math.PI*1/6],
                    ids:[1,2,3,4]
                },
            ]
        }
        else
        {
            enemyShipsData =
            [
                {
                    pos:[new Point3D(-80, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 40,
                    offDelay: 40,
                    ids:[1,2,4],
                    velocityScale:new Point3D(0, 0, .8),
                    velocityOffset:new Point3D(10, 0, 0),
                },

                {
                    pos:[new Point3D(80, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 45,
                    offDelay: 40,
                    ids:[1,2,3],
                    velocityScale:new Point3D(0, 0, .8),
                    velocityOffset:new Point3D(-10, 0, 0),
                },

                {
                    pos:[new Point3D(-50, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 50,
                    offDelay: 40,
                    ids:[1,3,4]
                },

                {
                    pos:[new Point3D(-20, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 40,
                    offDelay: 40,
                    ids:[1,2,3],
                },

                {
                    pos:[new Point3D(20, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 40,
                    offDelay: 40,
                    ids:[1,2,3],
                    accel:new Point3D(5, 15,-40)
                },

                {
                    pos:[new Point3D(50, 0, 1000)],
                    range:new Point3D(10, 35, 200),
                    spawnerWaveDelay: 45,
                    offDelay: 40,
                    ids:[2,3],
                },

                {
                    pos:[new Point3D(0, 25, 1000)],
                    range:new Point3D(20, 15, 200),
                    spawnerWaveDelay: 35,
                    offDelay: 40,
                    ids:[1,2],
                },

                {
                    pos:[new Point3D(0,-25, 1000)],
                    range:new Point3D(20, 15, 200),
                    spawnerWaveDelay: 40,
                    offDelay: 40,
                    ids:[1,2],
                },
            ]
        }

        let spawnPointData =
        [
            //------------------//
            //--Rocks-spawners--//
            //------------------//
            {
                pos:[new Point3D(25, -50, 400)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 48,
                offDelay: 28,
                angleMin: [Math.PI + Math.PI*1/5],
                angleMax: [Math.PI + Math.PI*2/3],
                ids:[5,6,7,8,9]
            },


            {
                pos:[new Point3D(-25, -50, 401)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 48,
                offDelay: 32,
                angleMin: [Math.PI*2 - Math.PI*1/5],
                angleMax: [Math.PI*2 - Math.PI*2/3],
                ids:[5,6,7,8,9]
            },

            {
                pos:[new Point3D(25, 50, 402)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 48,
                offDelay: 32,
                angleMin: [Math.PI*1/5],
                angleMax: [Math.PI*2/3],
                ids:[5,6,7,8,9]
            },

            {
                pos:[new Point3D(-25, 50, 403)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 48,
                offDelay: 28,
                angleMin: [Math.PI - Math.PI*1/5],
                angleMax: [Math.PI - Math.PI*2/3],
                ids:[5,6,7,8,9]
            },

            {
                pos:[new Point3D(-85, 0, 404)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 48,
                offDelay: 28,
                angleMin: [Math.PI*2 - Math.PI*1/6],
                angleMax: [Math.PI*2 + Math.PI*1/6],
                ids:[5,6,7,8,9]
            },

            {
                pos:[new Point3D(85, 0, 405)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 48,
                offDelay: 32,
                angleMin: [Math.PI - Math.PI*1/6],
                angleMax: [Math.PI + Math.PI*1/6],
                ids:[5,6,7,8,9]
            },

            //-------------------//
            //--Debris-spawners--//
            //-------------------//
            {
                pos:[new Point3D(25, -50, 399)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI + Math.PI*1/5],
                angleMax: [Math.PI + Math.PI*2/3],
                ids:[10,11,12,13,14,15]
            },


            {
                pos:[new Point3D(-25, -50, 398)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI*2 - Math.PI*1/5],
                angleMax: [Math.PI*2 - Math.PI*2/3],
                ids:[10,11,12,13,14,15]
            },

            {
                pos:[new Point3D(25, 50, 397)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI*1/5],
                angleMax: [Math.PI*2/3],
                ids:[10,11,12,13,14,15]
            },

            {
                pos:[new Point3D(-25, 50, 396)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI - Math.PI*1/5],
                angleMax: [Math.PI - Math.PI*2/3],
                ids:[10,11,12,13,14,15]
            },

            {
                pos:[new Point3D(-85, 0, 395)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI*2 - Math.PI*1/6],
                angleMax: [Math.PI*2 + Math.PI*1/6],
                ids:[10,11,12,13,14,15]
            },

            {
                pos:[new Point3D(85, 0, 394)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 36,
                offDelay: 28,
                angleMin: [Math.PI - Math.PI*1/6],
                angleMax: [Math.PI + Math.PI*1/6],
                ids:[10,11,12,13,14,15]
            },


            //-------------------//
            //--Crates-spawners--//
            //-------------------//
            {
                pos:[new Point3D(25, -50, 406)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 60,
                offDelay: 40,
                angleMin: [Math.PI + Math.PI*1/5],
                angleMax: [Math.PI + Math.PI*2/3],
                ids:[17,18,19,20]
            },


            {
                pos:[new Point3D(-25, -50, 407)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 60,
                offDelay: 36,
                angleMin: [Math.PI*2 - Math.PI*1/5],
                angleMax: [Math.PI*2 - Math.PI*2/3],
                ids:[17,18,19,20]
            },

            {
                pos:[new Point3D(25, 50, 408)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 60,
                offDelay: 44,
                angleMin: [Math.PI*1/5],
                angleMax: [Math.PI*2/3],
                ids:[17,18,19,20]
            },

            {
                pos:[new Point3D(-25, 50, 409)],
                range:new Point3D(20, 0, 0),
                spawnerWaveDelay: 60,
                offDelay: 40,
                angleMin: [Math.PI - Math.PI*1/5],
                angleMax: [Math.PI - Math.PI*2/3],
                ids:[17,18,19,20]
            },

            {
                pos:[new Point3D(-85, 0, 410)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 60,
                offDelay: 40,
                angleMin: [Math.PI*2 - Math.PI*1/6],
                angleMax: [Math.PI*2 + Math.PI*1/6],
                ids:[17,18,19,20]
            },

            {
                pos:[new Point3D(85, 0, 411)],
                range:new Point3D(0, 30, 0),
                spawnerWaveDelay: 60,
                offDelay: 48,
                angleMin: [Math.PI - Math.PI*1/6],
                angleMax: [Math.PI + Math.PI*1/6],
                ids:[17,18,19,20]
            },

            //------------------//
            //--Flare-spawners--//
            //------------------//
            {
                pos:[new Point3D(85, -30, 412), new Point3D(-20, 50, 413), new Point3D(-70, -50, 414)],
                range:new Point3D(0, 10, 0),
                spawnerWaveDelay: 72,
                offDelay: 60,
                angleMin: [Math.PI - Math.PI*1/8, Math.PI*1/6, Math.PI + Math.PI/2],
                angleMax: [Math.PI + Math.PI*1/3, Math.PI*2/3, Math.PI*2 - Math.PI*1/8],
                ids:[16]
            },
            // {
            //     pos:[new Point3D(-20, 50, 413)],
            //     range:new Point3D(10, 0, 0),
            //     spawnerWaveDelay: 72,
            //     offDelay: 60,
            //     angleMin: [Math.PI*1/6],
            //     angleMax: [Math.PI*2/3],
            //     ids:[16]
            // },
            // {
            //     pos:[new Point3D(-70, -50, 414)],
            //     range:new Point3D(5, 0, 0),
            //     spawnerWaveDelay: 72,
            //     offDelay: 60,
            //     angleMin: [Math.PI + Math.PI/2],
            //     angleMax: [Math.PI*2 - Math.PI*1/8],
            //     ids:[16]
            // },

            //----------------//
            //--Pod-spawners--//
            //----------------//
            {
                pos:[new Point3D(-85, 30, 416), new Point3D(20, -50, 417), new Point3D(70, 50, 418)],
                range:new Point3D(0, 10, 0),
                spawnerWaveDelay: 60,
                offDelay: 52,
                angleMin: [Math.PI*2 - Math.PI*1/8, Math.PI + Math.PI*1/6, Math.PI/2],
                angleMax: [Math.PI*2 + Math.PI*1/3, Math.PI + Math.PI*2/3, Math.PI - Math.PI*1/8],
                ids:[21]
            },
            // {
            //     pos:[new Point3D(20, -50, 417)],
            //     range:new Point3D(10, 0, 0),
            //     spawnerWaveDelay: 60,
            //     offDelay: 52,
            //     angleMin: [Math.PI + Math.PI*1/6],
            //     angleMax: [Math.PI + Math.PI*2/3],
            //     ids:[21]
            // },
            // {
            //     pos:[new Point3D(70, 50, 418)],
            //     range:new Point3D(5, 0, 0),
            //     spawnerWaveDelay: 60,
            //     offDelay: 52,
            //     angleMin: [Math.PI/2],
            //     angleMax: [Math.PI - Math.PI*1/8],
            //     ids:[21]
            // },

            //---------------------------//
            //--MotherOfTheMoon-spawner--//
            //---------------------------//
            // {
            //     pos:[new Point3D(70, -46, 1113)],
            //     range:new Point3D(0, 0, 0),
            //     startDelay: 80,
            //     spawnerWaveDelay: 160,
            //     offDelay: 120,
            //     // startDelay: 0,
            //     // spawnerWaveDelay: 0,
            //     // offDelay: 120,
            //     ids:[22]
            // },
            {
                pos:[new Point3D(-25, -25, 750), new Point3D(25, 25, 750)],
                range:new Point3D(5, 5, 0),
                spawnerWaveDelay: 200,
                startDelay: 20,
                offDelay: 80,
                ids:[22],
                // velocityScale:new Point3D(0, 0, 0),
                // velocityOffset:new Point3D(10, 0, 0),
            },

        ];

        spawnPointData = spawnPointData.concat(enemyShipsData);

        // test
        // spawnPointData =
        // [
        //     {
        //         pos:[new Point3D(-50, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[1],
        //         velocityScale:new Point3D(0, 0, 0),
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-35, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[2],
        //         velocityScale:new Point3D(0, 0, 0),
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-15, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[3],
        //         velocityScale:new Point3D(0, 0, 0),
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(5, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[4],
        //         velocityScale:new Point3D(0, 0, 0),
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(25, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[5],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(45, -50, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[6],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-50, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[7],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-30, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[8],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-10, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[9],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(10, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[10],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(30, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[11],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(50, -30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[12],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-50, -10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[13],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-30, -10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[14],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(30, -10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[15],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(50, -10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[16],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-50, 10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[17],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-30, 10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[18],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(30, 10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[19],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(50, 10, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[20],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(-50, 30, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[21],
        //         velocityScale:new Point3D(0, 0, 0),
        //         angleMin: [Math.PI + Math.PI*1/5],
        //         angleMax: [Math.PI + Math.PI*2/3],
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        //     {
        //         pos:[new Point3D(0, 0, 500)],
        //         range:new Point3D(0, 0, 0),
        //         spawnerWaveDelay: 150,
        //         offDelay: 0,
        //         ids:[22],
        //         velocityScale:new Point3D(0, 0, 0),
        //         // velocityOffset:new Point3D(10, 0, 0),
        //     },
        // ];

        for (let spawnerIdx=0; spawnerIdx<spawnPointData.length; spawnerIdx++)
        {
            let data = spawnPointData[spawnerIdx];
            let e = new Entity(C_Entity.SPAWNER);
            let s = new EnemySpawner(data);
            e.addComponent(s);
            this.app.eSys.addEntity(e);
        }

        //this.app.eSys.addEntity(this.getAsteroidSpawner());
    }

    // TODO add extra spawn delay when the Mother enters the stage and remove when she leaves
    changeSpawnersSpeed(speedFactor)
    {
        let spawners = this.app.eSys.getEntitiesByType(C_Entity.SPAWNER);
        for (let spawn in spawners)
        {
            let s = spawners[spawn].getComponent(EnemySpawner);
            s.deltaFactor = speedFactor;
        }
    }


    stopSpawners()
    {
        let spawners = this.app.eSys.getEntitiesByType(C_Entity.SPAWNER);
        for (let spawn in spawners)
        {
            spawners[spawn].queueForRemoval = true;
        }

        // let bots = this.app.eSys.getEntitiesByType(C_Entity.FRIENDLY_BOT);
        // for (let bot in bots)
        // {
        //     let friendlyBot = bots[bot].getComponent(FriendlyBot);
        //     friendlyBot.canShoot = false;
        // }

        this.app.eSys.setTimeScale(30);
        this.app.eSys.botsCanShoot = false;
    }


    createFormationSpawner(type)
    {
        let e = new Entity(C_Entity.FORMATION_SPAWNER);
        let s = new FormationSpawner(type);
        e.addComponent(s);
        this.app.eSys.addEntity(e);

        this.app.eSys.botsCanShoot = true;
    }


}


export default EntityFactory;